<template>
  <img :src="src" />
</template>

<script setup lang="ts">
defineProps<{
  src: string
}>()
</script>
